import { NgModule } from '@angular/core';

import { MomentFormatPipe } from './moment-format.pipe';
import { SafeResourceUrlPipe } from './safe-resource-url.pipe';

@NgModule({
    providers: [],
    declarations: [
        SafeResourceUrlPipe
    ],
    exports: [
        SafeResourceUrlPipe
    ]
})
export class UtilsModule { }
